import { Material } from '../../services/sculkwire';
import { State as AppState } from '..';

export const selectMaterials = (state: AppState): Material[] => state.materials;
